export default "__VITE_ASSET__SswX9uAe__"